import React from 'react'
import { View } from 'react-native'

export const ReactableView = ({ disable = false, children }: { disable?: boolean; children: React.ReactNode }) => {
  return <View pointerEvents={disable ? 'none' : undefined}>{children}</View>
}
